/* GREEXE theme helpers (carousel, ticker, video, scroll-top, cart timer, sticky ATC) */
(function () {
  'use strict';

  /* ---------------- Carousel ---------------- */
  if (!customElements.get('gx-carousel')) {
    class GxCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.gx-track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prev = this.querySelector('[data-gx-prev]');
        this.next = this.querySelector('[data-gx-next]');
        this.dotsWrap = this.querySelector('[data-gx-dots]');
        this.loop = this.dataset.loop === 'true';
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = Math.max(parseFloat(this.dataset.speed || '5'), 1) * 1000;

        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        window.addEventListener('resize', () => this.update());
        this.buildDots();
        this.update();

        if (this.autoplay) {
          // only auto-advance while the carousel is on screen and the tab is visible
          this._vis = true;
          if ('IntersectionObserver' in window) {
            new IntersectionObserver((en) => { this._vis = en[0].isIntersecting; }).observe(this);
          }
          this.start();
          ['mouseenter', 'touchstart', 'focusin'].forEach((e) =>
            this.addEventListener(e, () => this.stop(), { passive: true })
          );
          ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.start()));
        }
      }
      perView() {
        if (!this.slides.length) return 1;
        const w = this.slides[0].getBoundingClientRect().width || 1;
        return Math.max(1, Math.round(this.track.clientWidth / w));
      }
      pages() {
        return Math.max(1, this.slides.length - this.perView() + 1);
      }
      index() {
        if (!this.slides.length) return 0;
        const left = this.track.scrollLeft;
        let best = 0;
        let min = Infinity;
        this.slides.forEach((s, i) => {
          const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left);
          if (d < min) { min = d; best = i; }
        });
        return best;
      }
      scrollToIndex(i) {
        const s = this.slides[i];
        if (!s) return;
        this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }
      go(dir) {
        const last = this.pages() - 1;
        let i = this.index() + dir;
        if (i > last) i = this.loop || this.autoplay ? 0 : last;
        if (i < 0) i = this.loop ? last : 0;
        this.scrollToIndex(i);
      }
      buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        const n = this.pages();
        if (n < 2) return;
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'gx-dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', () => this.scrollToIndex(i));
          this.dotsWrap.appendChild(b);
        }
        this.dotsCount = n;
      }
      onScroll() {
        window.clearTimeout(this._t);
        this._t = window.setTimeout(() => this.update(), 60);
      }
      update() {
        if (this.dotsWrap && this.dotsCount !== this.pages()) this.buildDots();
        const i = this.index();
        const last = this.pages() - 1;
        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((d, k) => d.setAttribute('aria-current', k === Math.min(i, last) ? 'true' : 'false'));
        }
        const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
        [this.prev, this.next].forEach((b) => b && (b.hidden = !scrollable));
        if (!this.loop && !this.autoplay) {
          if (this.prev) this.prev.disabled = i <= 0;
          if (this.next) this.next.disabled = i >= last;
        }
      }
      start() {
        this.stop();
        this.timer = window.setInterval(() => {
          if (this._vis !== false && !document.hidden) this.go(1);
        }, this.speed);
      }
      stop() {
        window.clearInterval(this.timer);
      }
      disconnectedCallback() {
        this.stop();
      }
    }
    customElements.define('gx-carousel', GxCarousel);
  }

  /* ---------------- Sale countdown ---------------- */
  if (!customElements.get('gx-countdown')) {
    class GxCountdown extends HTMLElement {
      connectedCallback() {
        const raw = (this.dataset.end || '').trim();
        const offset = this.dataset.offset || '+05:00';
        const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
        this.end = m ? Date.parse(`${m[1]}-${m[2]}-${m[3]}T${(m[4] || '23').padStart(2, '0')}:${m[5] || '59'}:00${offset}`) : NaN;
        this.section = this.closest('.shopify-section');
        if (isNaN(this.end)) {
          if (!window.Shopify || !window.Shopify.designMode) this.hideSection();
          else this.querySelector('[data-gx-cd-timer]').insertAdjacentHTML('afterend', '<p class="gx-editor-note">Enter "Sale ends at" (YYYY-MM-DD HH:MM) to start the timer.</p>');
          return;
        }
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      hideSection() {
        if (this.section) this.section.style.display = 'none';
        else this.style.display = 'none';
      }
      tick() {
        let left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        if (left <= 0) {
          clearInterval(this.timer);
          if (this.dataset.ended === 'hide_section' && !(window.Shopify && window.Shopify.designMode)) return this.hideSection();
          const t = this.querySelector('[data-gx-cd-timer]');
          const e = this.querySelector('[data-gx-cd-ended]');
          if (t) t.hidden = true;
          if (e) e.hidden = false;
          return;
        }
        const set = (k, v) => { const el = this.querySelector(`[data-gx-cd="${k}"]`); if (el) el.textContent = String(v).padStart(2, '0'); };
        set('days', Math.floor(left / 86400)); left %= 86400;
        set('hours', Math.floor(left / 3600)); left %= 3600;
        set('mins', Math.floor(left / 60));
        set('secs', left % 60);
      }
    }
    customElements.define('gx-countdown', GxCountdown);
  }

  /* ---------------- Bundle & save (sets the quantity that is added to cart) ---------------- */
  if (!customElements.get('gx-bundle')) {
    class GxBundle extends HTMLElement {
      connectedCallback() {
        this.hidden_ = this.querySelector('[data-gx-bundle-qty]');
        this.qtyInput = document.getElementById(this.dataset.qtyInput);
        // If the theme's own quantity selector is on the page, use it instead of our hidden field.
        if (this.qtyInput && this.hidden_) { this.hidden_.remove(); this.hidden_ = null; }
        this.opts = Array.from(this.querySelectorAll('.gx-bundle__opt'));
        this.opts.forEach((o) => o.addEventListener('click', () => this.select(o)));
        const active = this.querySelector('.gx-bundle__opt.is-active') || this.opts[0];
        if (active) this.select(active);
      }
      select(opt) {
        this.opts.forEach((o) => { o.classList.toggle('is-active', o === opt); o.setAttribute('aria-checked', o === opt ? 'true' : 'false'); });
        const q = opt.dataset.qty || '1';
        if (this.hidden_) this.hidden_.value = q;
        if (this.qtyInput) {
          this.qtyInput.value = q;
          this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    customElements.define('gx-bundle', GxBundle);
  }

  /* ---------------- Videos: load only near the screen, play only while visible ---------------- */
  const conn = navigator.connection || {};
  const lowData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canAutoplay = !lowData && !reduceMotion;

  // Read the HLS master playlist and pick ONE fixed rendition, so small video tiles never
  // climb to 1080p on fast networks and never stall on slow ones.
  const hlsOK = (() => { try { return !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl'); } catch (e) { return false; } })();
  function pickRendition(v) {
    const master = v.dataset.srcHls;
    const fallback = () => (hlsOK && master) || v.dataset.srcSm || v.dataset.srcLg || '';
    if (!master || !window.fetch) return Promise.resolve(fallback());
    const slow = lowData || /3g/.test(conn.effectiveType || '');
    const small = window.matchMedia('(max-width: 749px)').matches;
    const maxH = slow || small ? 480 : 720;
    return fetch(master)
      .then((r) => (r.ok ? r.text() : ''))
      .then((txt) => {
        const lines = txt.split('\n');
        let best = null;
        let lowest = null;
        for (let i = 0; i < lines.length; i++) {
          const m = lines[i].match(/RESOLUTION=(\d+)x(\d+)/);
          const uri = (lines[i + 1] || '').trim();
          if (!m || !uri || uri[0] === '#') continue;
          const item = { h: +m[2], uri: uri }; // Shopify labels renditions by height (480p/720p/1080p)
          if (!lowest || item.h < lowest.h) lowest = item;
          if (item.h <= maxH && (!best || item.h > best.h)) best = item;
        }
        const pick = best || lowest;
        if (!pick) return fallback();
        const base = master.split('?')[0].replace(/[^/]*$/, '');
        if (hlsOK) return base + pick.uri;
        // same rendition as a plain MP4 (e.g. ...SD-480p.1.5Mbps.hls.123_.m3u8 -> ...SD-480p-1.5Mbps-123.mp4)
        const mp4 = pick.uri.replace(/\.(SD|HD)-(\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/, '.$1-$2-$3-$4.mp4');
        return mp4 !== pick.uri ? base + mp4 : fallback();
      })
      .catch(fallback);
  }

  function hydrateVideo(v) {
    if (v._gxReady) return v._gxReady;
    if (v.dataset.poster) v.poster = v.dataset.poster;
    v._gxReady = pickRendition(v).then((src) => {
      if (!src) return;
      v.addEventListener('error', () => {
        const fb = v.dataset.srcSm || v.dataset.srcLg;
        if (fb && v.src.indexOf(fb) === -1) { v.src = fb; if (v._gxVisible) v.play().catch(() => {}); }
      }, { once: true });
      v.src = src;
    });
    return v._gxReady;
  }
  function playVideo(v) {
    hydrateVideo(v).then(() => {
      if (!v._gxVisible && !v._gxUserPlay) return;
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    });
  }

  function initVideos(root) {
    const vids = (root || document).querySelectorAll('[data-gx-video] video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach((v) => { v._gxVisible = true; if (canAutoplay) playVideo(v); else hydrateVideo(v); });
      return;
    }
    // 1) fetch poster + pick the source shortly before the video scrolls into view
    const near = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { hydrateVideo(e.target); near.unobserve(e.target); } }),
      { rootMargin: '300px 300px' }
    );
    // 2) play only while at least half visible, pause otherwise (saves data + battery)
    const seen = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          const v = e.target;
          v._gxVisible = e.isIntersecting;
          if (e.isIntersecting && (canAutoplay || v._gxUserPlay) && !document.hidden) playVideo(v);
          else if (!e.isIntersecting) v.pause();
        });
      },
      { threshold: 0.5 }
    );
    vids.forEach((v) => {
      v.muted = true;
      near.observe(v);
      seen.observe(v);
      // tap to play/pause (needed when autoplay is skipped on data-saver connections)
      v.addEventListener('click', () => {
        if (v.paused) { v._gxUserPlay = true; playVideo(v); } else { v._gxUserPlay = false; v.pause(); }
      });
      const wrap = v.closest('[data-gx-video]');
      const btn = wrap && wrap.querySelector('[data-gx-sound]');
      if (btn) {
        btn.addEventListener('click', () => {
          v.muted = !v.muted;
          btn.setAttribute('aria-pressed', String(!v.muted));
          if (!v.muted) { v._gxUserPlay = true; playVideo(v); }
        });
      }
    });
  }
  // pause every video while the tab/app is in the background, resume the visible ones on return
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('[data-gx-video] video').forEach((v) => {
      if (document.hidden) v.pause();
      else if (v._gxVisible && (canAutoplay || v._gxUserPlay)) playVideo(v);
    });
  });

  /* ---------------- Scroll to top ---------------- */
  function initScrollTop() {
    const btn = document.querySelector('[data-gx-scroll-top]');
    if (!btn) return;
    const toggle = () => (btn.hidden = window.scrollY < 400);
    window.addEventListener('scroll', toggle, { passive: true });
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    toggle();
  }

  /* ---------------- Cart reservation timer ---------------- */
  function initCartTimer() {
    const KEY = 'gx-cart-timer-end';
    const tick = () => {
      const el = document.querySelector('[data-gx-cart-timer]');
      if (!el) return;
      const minutes = parseInt(el.dataset.minutes || '5', 10);
      let end;
      try {
        end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
      } catch (e) {
        end = 0;
      }
      const now = Date.now();
      if (!end || end < now) {
        end = now + minutes * 60000;
        try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
      }
      const left = Math.max(0, Math.round((end - now) / 1000));
      const out = el.querySelector('[data-gx-timer-value]');
      if (out) out.textContent = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
    };
    tick();
    window.setInterval(tick, 1000);
  }

  /* ---------------- Sticky add to cart ---------------- */
  function initStickyAtc() {
    const bar = document.querySelector('[data-gx-sticky-atc]');
    if (!bar) return;
    const mainBtn = document.getElementById(bar.dataset.button);
    const section = mainBtn && mainBtn.closest('product-info, section');
    const btn = bar.querySelector('[data-gx-sticky-btn]');
    if (!mainBtn || !btn) return;

    const mode = bar.dataset.display;
    const show = (v) => bar.classList.toggle('is-visible', v);
    if (mode === 'always') show(true);
    else {
      let ticking = false;
      const check = () => {
        ticking = false;
        show(mainBtn.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
      }, { passive: true });
      check();
    }

    btn.addEventListener('click', () => {
      if (bar.dataset.function === 'scroll') {
        (section || mainBtn).scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        mainBtn.click();
      }
    });

    const sync = () => {
      btn.disabled = mainBtn.disabled;
      const label = mainBtn.querySelector('span');
      if (mainBtn.disabled && label) btn.querySelector('span').textContent = label.textContent.trim();
      else btn.querySelector('span').textContent = btn.dataset.label;
    };
    new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    sync();
  }

  function init() {
    initVideos();
    initScrollTop();
    initCartTimer();
    initStickyAtc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => initVideos(e.target));
})();
